import React, { useEffect } from 'react';
import { HomePageContent } from "src/pages/HomePageContent/HomePageContent";
import Helper from 'src/helper/Helper';
// import { useProductStore } from '../hooks/product';

export function ProductListing() {
    // const [{ productHeadingData }, { }, { }, { }] = useProductStore();
    useEffect(() => {
        Helper.feedBackButtonScript()
       }, []);
    return (
        <>

        {/* post MVP implementation */}
            {/* <div className='container'>
                <div className='bs5 row mb-4'>
                    <div className="col-6">
                        <h1 className="font-apecru font-30"><b>{productHeadingData?.categoryName}</b></h1>
                        <p className="font-arial">{productHeadingData?.categoryDescription}</p>
                    </div>
                    <div className="col-6 prodlisting-headimg">
                        <img src={productHeadingData?.categoryImage}/>
                    </div>
                </div>
            </div> */}
            <HomePageContent />
        </>
    );
}
